import { FormattedMessage } from "react-intl";
import { Switch } from "@mui/material";
import { useEffect, useState } from "react";
import Button from "./Button";
import { CONSTANT } from "../utils/constants";
import { setStoreItem, getStoreItem } from "../utils/storageUtils";
import "../styles/CookiePanel.css";

const CookiePanel = () => {
  const [display, setDisplay] = useState(false);
  const [performance, setPerformance] = useState(false);
  const [tipShow, setTipShow] = useState({ strict: false, performance: false });

  useEffect(() => {
    getStoreItem("cookiePref") ? null : setDisplay(true);
  }, []);

  const onTargetingSwitched = () => {
    setPerformance(!performance);
  };

  const onSubmit = (choose: "all" | "partial") => {
    switch(choose) {
      case "all":
        setStoreItem("cookiePref", { strict: true, performance: true });
        setDisplay(false);
        break;
      case "partial":
        setStoreItem("cookiePref", { strict: true, performance });
        setDisplay(false);
        break;
      default:
        setDisplay(false);
    }
  };

  const onMouseEnterIcon = (tip: "strict" | "performance") => {
    setTipShow({ ...tipShow, [tip]: true });
  };

  const onMouseLeaveIcon = (tip: "strict" | "performance") => {
    setTipShow({ ...tipShow, [tip]: false });
  };

  return display ? (
    <div className="cookiepanel">
      <div className="cookiepanel-title">
        <h1><FormattedMessage id="cookie_settings" /></h1>
      </div>
      <div className="cookiepanel-description">
        <p>
          <FormattedMessage id="cookie_settings_desc" />&nbsp;
          <a href={CONSTANT.URL.COOKIE_NOTICE}><FormattedMessage id="cookie_learn_more" /></a>
        </p>
      </div>
      <div className="cookiepanel-options">
        <div className="cookiepanel-switch">
          <FormattedMessage id="cookie_toggle_required" />
          <Switch defaultChecked disabled></Switch>
          <div className="cookiepanel-tipicon" onMouseEnter={ () => onMouseEnterIcon("strict") } onMouseLeave={ () => onMouseLeaveIcon("strict") }></div>
          <div className={`cookiepanel-tipcontent ${tipShow.strict ? "cookiepanel-tipcontent-show": ""}`}>
            <FormattedMessage id="cookie_toggle_required_desc" />
          </div>
        </div>
        <div className="cookiepanel-switch">
          <FormattedMessage id="cookie_toggle_performance" />
          <Switch onClick={ onTargetingSwitched }></Switch>
          <div className="cookiepanel-tipicon" onMouseEnter={ () => onMouseEnterIcon("performance") } onMouseLeave={ () => onMouseLeaveIcon("performance") }></div>
          <div className={`cookiepanel-tipcontent ${tipShow.performance ? "cookiepanel-tipcontent-show": ""}`}>
            <FormattedMessage id="cookie_toggle_performance_desc" />
          </div>
        </div>
      </div>
      <div className="cookiepanel-confirm">
        <Button className="cookiepanel-button" color="red" localeId="cookie_accept_all" link="" onClick={ () => onSubmit("all") } />
        <Button className="cookiepanel-button" color="gray" localeId="cookie_accept_selected" link="" onClick={ () => onSubmit("partial") } />
      </div>
    </div>
  ) : null;
};

export default CookiePanel;
